import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import { useAuth } from '../../context/AuthContext';
import { useVeliOgrenci } from '../../context/VeliOgrenciContext';
import VeliOgrenciSecici from '../../components/parent/VeliOgrenciSecici';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import toast from 'react-hot-toast';

const PROGRAM_GUNLERI = ['Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi', 'Pazar'];
const PROGRAM_GUN_ETIKETLERI = {
  Pazartesi: 'Pazartesi',
  Sali: 'Salı',
  Carsamba: 'Çarşamba',
  Persembe: 'Perşembe',
  Cuma: 'Cuma',
  Cumartesi: 'Cumartesi',
  Pazar: 'Pazar',
  Calisma: 'Çalışma',
};
const PROGRAM_GUN_KISA = {
  Pazartesi: 'Pzt',
  Sali: 'Sal',
  Carsamba: 'Çar',
  Persembe: 'Per',
  Cuma: 'Cum',
  Cumartesi: 'Cmt',
  Pazar: 'Paz',
  Calisma: 'Çalışma',
};
const CALISMA_PROGRAM_TURU = {
  haftalik: { label: 'Haftalık', planLabel: 'Haftalık Plan', helper: 'Haftalık plan', badge: 'badge-info' },
  gunluk: { label: 'Günlük', planLabel: 'Günlük Plan', helper: 'Günlük plan', badge: 'badge-success' },
  calisma: { label: 'Çalışma', planLabel: 'Çalışma Programı', helper: 'Çalışma programı', badge: 'badge-warning' },
};
const VARSAYILAN_PROGRAM_SAATLERI = {
  Pazartesi: { bas: '09:00', bit: '17:00', aktif: true },
  Sali: { bas: '09:00', bit: '17:00', aktif: true },
  Carsamba: { bas: '09:00', bit: '17:00', aktif: true },
  Persembe: { bas: '09:00', bit: '17:00', aktif: true },
  Cuma: { bas: '09:00', bit: '17:00', aktif: true },
  Cumartesi: { bas: '09:00', bit: '17:00', aktif: true },
  Pazar: { bas: '09:00', bit: '17:00', aktif: true },
};
const VARSAYILAN_PROGRAM_TENEFUSLERI = [
  { bas: '09:40', bit: '09:50' },
  { bas: '10:30', bit: '10:40' },
  { bas: '11:20', bit: '11:30' },
  { bas: '12:10', bit: '13:00' },
  { bas: '13:40', bit: '13:50' },
  { bas: '14:30', bit: '14:40' },
  { bas: '15:20', bit: '15:30' },
];

function programDakikaYap(saat = '00:00') {
  const [h, m] = saat.split(':').map(Number);
  return h * 60 + m;
}

function programSaatStr(h, m) {
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

function programGunIcinSaatlerUret(basDk, bitDk, sureDk, tenefusler) {
  const saatler = [];
  let current = basDk;

  while (current + sureDk <= bitDk) {
    const slotBit = current + sureDk;
    const cakisan = tenefusler.find((t) => {
      const tBas = programDakikaYap(t.bas);
      const tBit = programDakikaYap(t.bit);
      return current < tBit && slotBit > tBas;
    });

    if (!cakisan) {
      saatler.push({
        bas: programSaatStr(Math.floor(current / 60), current % 60),
        bit: programSaatStr(Math.floor(slotBit / 60), slotBit % 60),
      });
      current = slotBit;
    } else {
      current = Math.max(current + 1, programDakikaYap(cakisan.bit));
    }
  }

  return saatler;
}

function programTumGunlerIcinSaatler(gunSaatleri, sureDk, tenefusler) {
  const result = {};
  PROGRAM_GUNLERI.forEach((gun) => {
    const ayar = gunSaatleri?.[gun];
    if (!ayar?.aktif) return;
    result[gun] = programGunIcinSaatlerUret(
      programDakikaYap(ayar.bas),
      programDakikaYap(ayar.bit),
      sureDk,
      tenefusler
    );
  });
  return result;
}

function normalizeProgramSlotlari(raw = {}) {
  const result = {};
  PROGRAM_GUNLERI.forEach((gun) => {
    if (!Array.isArray(raw?.[gun])) return;
    result[gun] = raw[gun]
      .filter((slot) => slot?.bas && slot?.bit)
      .map((slot) => ({ bas: slot.bas.slice(0, 5), bit: slot.bit.slice(0, 5) }));
  });
  return result;
}

// ── 1. YOKLAMA TAKİP SAYFASI ─────────────────────────────────────────
export function OgrenciYoklamaPage() {
  const [gecmis, setGecmis] = useState([]);
  const [filtreliGecmis, setFiltreliGecmis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [istatistik, setIstatistik] = useState({ mevcut: 0, devamsiz: 0, gec: 0, izinli: 0 });
  const [seciliFiltre, setSeciliFiltre] = useState('all');
  const { user } = useAuth();

  const loadVeriler = useCallback(async () => {
    if (!user || !user.id) return;
    setLoading(true);
    try {
      const oRes = await axios.get(`/ogrenciler?user_id=${user.id}`);
      const myProfile = oRes.data?.data?.find(o => o.email === user.email) || oRes.data?.data?.[0];

      if (myProfile && myProfile.id) {
        const ogrenciTabloId = myProfile.id;
        const yRes = await axios.get(`/yoklama/ogrenci/${ogrenciTabloId}`);

        if (yRes.data.success) {
          const kayıtlar = yRes.data.data?.kayitlar || [];
          const ozet = yRes.data.data?.ozet || {};
          setGecmis(kayıtlar);
          setFiltreliGecmis(kayıtlar);
          setIstatistik({
            mevcut: parseInt(ozet.mevcut || 0),
            devamsiz: parseInt(ozet.devamsiz || 0),
            gec: parseInt(ozet.gec || 0),
            izinli: parseInt(ozet.izinli || 0)
          });
        }
      } else {
        toast.error('Profil verilerine ulaşılamadı.');
      }
    } catch (e) {
      console.error('Veri yükleme hatası:', e.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    loadVeriler();
  }, [loadVeriler]);

  useEffect(() => {
    if (seciliFiltre === 'all') {
      setFiltreliGecmis(gecmis);
    } else {
      setFiltreliGecmis(gecmis.filter(y => y.durum === seciliFiltre));
    }
  }, [seciliFiltre, gecmis]);

  const DURUM_CONFIG = {
    mevcut: { label: 'Mevcut', color: '#10B981', icon: '✅', bg: 'rgba(16,185,129,0.1)' },
    devamsiz: { label: 'Devamsız', color: '#EF4444', icon: '❌', bg: 'rgba(239,68,68,0.1)' },
    gec: { label: 'Geç', color: '#F59E0B', icon: '⏰', bg: 'rgba(245,158,11,0.1)' },
    izinli: { label: 'İzinli', color: '#3B82F6', icon: '📋', bg: 'rgba(59,130,246,0.1)' }
  };

  const chartData = [
    { name: 'Mevcut', value: istatistik.mevcut, color: DURUM_CONFIG.mevcut.color },
    { name: 'Devamsız', value: istatistik.devamsiz, color: DURUM_CONFIG.devamsiz.color },
    { name: 'Geç', value: istatistik.gec, color: DURUM_CONFIG.gec.color },
  ].filter(d => d.value > 0);

  const getChipStyle = (filterKey) => ({
    cursor: 'pointer',
    padding: '8px 16px',
    borderRadius: '12px',
    fontSize: '0.85rem',
    fontWeight: 600,
    transition: 'all 0.2s ease',
    border: '1.5px solid',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: seciliFiltre === filterKey ? 'var(--accent)' : 'var(--bg-card)',
    borderColor: seciliFiltre === filterKey ? 'var(--accent)' : 'var(--border)',
    color: seciliFiltre === filterKey ? '#fff' : 'var(--text-secondary)',
    boxShadow: seciliFiltre === filterKey ? '0 4px 12px rgba(var(--accent-rgb), 0.3)' : 'none'
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div className="animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.5rem', fontWeight: 800 }}>📉 Devamsızlık Takibi</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Ders katılım durumunu ve istatistiklerini incele</p>
        </div>
        <button onClick={loadVeriler} className="btn btn-ghost btn-sm" style={{ cursor: 'pointer' }}>🔄 Yenile</button>
      </div>

      <div className="grid-2 animate-fadeInUp stagger-1">
        <div className="card" style={{ display: 'flex', alignItems: 'center', minHeight: 200 }}>
          <div style={{ flex: 1, height: 180 }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={chartData} innerRadius={50} outerRadius={70} paddingAngle={5} dataKey="value">
                  {chartData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} />)}
                </Pie>
                <RechartsTooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {Object.entries(DURUM_CONFIG).filter(([k]) => k !== 'izinli').map(([key, cfg]) => (
              <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>{cfg.icon} {cfg.label}</span>
                <span style={{ fontWeight: 800, color: cfg.color }}>{istatistik[key]}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="card" style={{ background: 'linear-gradient(135deg, var(--accent-dim) 0%, var(--bg-card) 100%)' }}>
          <div className="section-title">📊 Katılım Durumu</div>
          <div style={{ marginTop: 15 }}>
            <div style={{ fontSize: '2.5rem', fontWeight: 900, color: 'var(--accent)' }}>
              %{istatistik.mevcut + istatistik.devamsiz > 0
                ? ((istatistik.mevcut / (istatistik.mevcut + istatistik.devamsiz)) * 100).toFixed(1)
                : '0'}
            </div>
            <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Genel Derse Katılım Oranı</div>
            <div style={{ marginTop: 20, padding: '12px', background: 'var(--bg-elevated)', borderRadius: '12px', fontSize: '0.8rem' }}>
              💡 <strong>İpucu:</strong> Devamsızlıkların dershane kural sınırını aşmamasına dikkat etmelisin.
            </div>
          </div>
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-2" style={{ padding: '16px', border: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', gap: 10, overflowX: 'auto', paddingBottom: 4 }}>
          <button style={getChipStyle('all')} onClick={() => setSeciliFiltre('all')}>Tümü</button>
          <button style={getChipStyle('mevcut')} onClick={() => setSeciliFiltre('mevcut')}>✅ Mevcut</button>
          <button style={getChipStyle('devamsiz')} onClick={() => setSeciliFiltre('devamsiz')}>❌ Devamsız</button>
          <button style={getChipStyle('gec')} onClick={() => setSeciliFiltre('gec')}>⏰ Geç</button>
          {/* İzinli butonu buradan kaldırıldı */}
        </div>
      </div>

      <div className="card animate-fadeInUp stagger-3">
        <div className="section-title" style={{ marginBottom: 16 }}>🗓 Detaylı Yoklama Kayıtları</div>
        {loading ? <div className="page-loader" style={{ minHeight: 150 }}><div className="spinner" /></div> :
          filtreliGecmis.length === 0 ? <div className="empty-state" style={{ padding: '40px 0' }}>
            <div style={{ fontSize: '2rem' }}>🔍</div>
            <p>Seçilen filtreye uygun kayıt bulunamadı</p>
          </div> :
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {filtreliGecmis.map((y, i) => {
                const cfg = DURUM_CONFIG[y.durum] || { label: y.durum, color: '#94A3B8', icon: '❓', bg: 'var(--bg-elevated)' };
                return (
                  <div key={i} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '14px 18px', background: 'var(--bg-elevated)', borderRadius: '14px',
                    borderLeft: `5px solid ${cfg.color}`, transition: 'transform 0.2s', cursor: 'default'
                  }} className="hover-scale">
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{ fontWeight: 700, fontSize: '1rem' }}>{y.ders_adi}</span>
                        <span className="badge" style={{ fontSize: '0.65rem', padding: '2px 6px' }}>{y.sinif_adi}</span>
                      </div>
                      <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>📅 {new Date(y.tarih).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' })}</div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>🕒 {y.baslangic_saati ? y.baslangic_saati.substring(0, 5) : '--:--'}</div>
                      </div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{
                        background: cfg.bg, color: cfg.color, padding: '6px 12px', borderRadius: '10px',
                        fontSize: '0.75rem', fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 6
                      }}>
                        {cfg.icon} {cfg.label.toUpperCase()}
                      </div>
                      {y.katilim_saati && <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)', marginTop: 4 }}>Giriş: {y.katilim_saati.substring(0, 5)}</div>}
                    </div>
                  </div>
                );
              })}
            </div>
        }
      </div>
    </div>
  );
}

export function OgrenciProgramPage() {
  const { user } = useAuth();
  const veliCtx = useVeliOgrenci();
  const seciliVeliOgrenci = user?.role === 'veli' ? veliCtx?.seciliOgrenci : null;
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 900 : false);
  const [mobilGun, setMobilGun] = useState('Pazartesi');
  const [loading, setLoading] = useState(true);
  const [ogrenci, setOgrenci] = useState(null);
  const [program, setProgram] = useState([]);
  const [gunSaatleri, setGunSaatleri] = useState(VARSAYILAN_PROGRAM_SAATLERI);
  const [gunSlotlari, setGunSlotlari] = useState({});
  const [dersSuresiDk, setDersSuresiDk] = useState(40);

  const loadProgram = useCallback(async () => {
    if (!user?.id) return;
    setLoading(true);
    try {
      let myProfile = null;
      if (user.role === 'veli' && seciliVeliOgrenci?.id) {
        myProfile = seciliVeliOgrenci;
      } else {
        const ogrRes = await axios.get(`/ogrenciler?user_id=${user.id}`);
        myProfile = ogrRes.data?.data?.find((item) => item.email === user.email) || ogrRes.data?.data?.[0];
      }

      if (!myProfile?.id) {
        setOgrenci(null);
        setProgram([]);
        return;
      }

      const detayRes = await axios.get(`/ogrenciler/${myProfile.id}`);
      const detay = detayRes.data?.success ? detayRes.data.data : myProfile;

      if (!detay?.sinif_id) {
        setOgrenci(detay || null);
        setProgram([]);
        return;
      }

      const [programRes, ayarRes] = await Promise.all([
        axios.get('/ders-programi', { params: { sinif_id: detay.sinif_id } }),
        axios.get('/program-ayarlari'),
      ]);

      const ayarData = ayarRes.data?.success ? (ayarRes.data.data || {}) : {};
      const dersSuresi = Number(ayarData.ders_suresi_dk) || 40;
      const tenefusler = Array.isArray(ayarData.tenefusler) && ayarData.tenefusler.length > 0
        ? ayarData.tenefusler
        : VARSAYILAN_PROGRAM_TENEFUSLERI;
      const saatler = ayarData.gun_saatleri && Object.keys(ayarData.gun_saatleri).length > 0
        ? ayarData.gun_saatleri
        : VARSAYILAN_PROGRAM_SAATLERI;
      const slotlar = normalizeProgramSlotlari(ayarData.gun_slotlari);

      setOgrenci(detay);
      setProgram(programRes.data?.success ? (programRes.data.data || []) : []);
      setDersSuresiDk(dersSuresi);
      setGunSaatleri(saatler);
      setGunSlotlari(
        Object.keys(slotlar).length > 0 ? slotlar : programTumGunlerIcinSaatler(saatler, dersSuresi, tenefusler)
      );
    } catch (err) {
      toast.error(err.response?.data?.message || 'Ders programı yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, [user, seciliVeliOgrenci]);

  useEffect(() => {
    loadProgram();
  }, [loadProgram]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const aktifGunler = PROGRAM_GUNLERI.filter((gun) => gunSaatleri?.[gun]?.aktif);
  const tumSlotlar = [];
  aktifGunler.forEach((gun) => {
    (gunSlotlari[gun] || []).forEach((slot) => {
      if (!tumSlotlar.some((item) => item.bas === slot.bas && item.bit === slot.bit)) {
        tumSlotlar.push(slot);
      }
    });
  });
  tumSlotlar.sort((a, b) => programDakikaYap(a.bas) - programDakikaYap(b.bas));

  const programMap = {};
  program.forEach((item) => {
    programMap[`${item.gun}_${item.baslangic_saati}`] = item;
  });

  const jsGunMap = ['Pazar', 'Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi'];
  const bugun = jsGunMap[new Date().getDay()];
  const bugunDersleri = program
    .filter((ders) => ders.gun === bugun)
    .sort((a, b) => programDakikaYap(a.baslangic_saati) - programDakikaYap(b.baslangic_saati));
  const aktifMobilGun = aktifGunler.includes(mobilGun) ? mobilGun : (aktifGunler[0] || 'Pazartesi');
  const gorunenGunler = isMobile ? [aktifMobilGun] : aktifGunler;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {user?.role === 'veli' && <VeliOgrenciSecici />}
      <div
        className="animate-fadeInUp"
        style={{
          background: 'linear-gradient(135deg, #0F2854 0%, #1D4ED8 50%, #22C55E 100%)',
          borderRadius: 24,
          padding: isMobile ? '16px 14px' : '22px 24px',
          color: '#fff',
          boxShadow: '0 14px 30px rgba(29, 78, 216, 0.18)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div style={{ position: 'absolute', right: -30, top: -30, width: 130, height: 130, borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: '0.7rem', letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.72, fontWeight: 800 }}>
            Ogrenci Programi
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, marginTop: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <h2 style={{ margin: 0, fontFamily: 'var(--font-ui)', fontSize: isMobile ? '1.3rem' : '1.7rem', lineHeight: 1.05, fontWeight: 800 }}>
                {ogrenci?.sinif_adi || 'Sinif Programim'}
              </h2>
              <div style={{ marginTop: 6, fontSize: '0.88rem', color: 'rgba(255,255,255,0.84)', maxWidth: 700 }}>
                Kendi sinifinizin haftalik ders programi burada gorunur. Ogretmen ve saat bilgilerini tek ekranda takip edebilirsiniz.
              </div>
            </div>
            <div style={{ padding: '10px 14px', borderRadius: 16, background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.16)', minWidth: isMobile ? '100%' : 190 }}>
              <div style={{ fontSize: '0.68rem', opacity: 0.72, marginBottom: 4 }}>Bugunku Program</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1rem', fontWeight: 800 }}>
                {bugunDersleri.length > 0 ? `${bugunDersleri.length} ders` : 'Ders yok'}
              </div>
              <div style={{ fontSize: '0.74rem', opacity: 0.84, marginTop: 3 }}>{PROGRAM_GUN_ETIKETLERI[bugun] || 'Bugun'}</div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="page-loader"><div className="spinner" /></div>
      ) : (
        <>
          <div className="animate-fadeInUp stagger-1" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
            <div className="stat-card" style={{ '--stat-color': '#10B981', padding: 16 }}>
              <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Aktif Gun</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.7rem', fontWeight: 900 }}>{aktifGunler.length}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Programin acik oldugu gun sayisi</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#2563EB', padding: 16 }}>
              <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Toplam Ders</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.7rem', fontWeight: 900 }}>{program.length}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Haftalik planlanan slot</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#F97316', padding: 16 }}>
              <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Sinif</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.15rem', fontWeight: 900, lineHeight: 1.15 }}>{ogrenci?.sinif_adi || '-'}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Kayitli sinifiniz</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#7C3AED', padding: 16 }}>
              <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Ders Suresi</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.7rem', fontWeight: 900 }}>{dersSuresiDk} dk</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Tek slot suresi</div>
            </div>
          </div>

          <div className="card" style={{ padding: 18 }}>
            <div className="section-header" style={{ marginBottom: 12 }}>
              <div>
                <div className="section-title">Bugunku Akis</div>
                <div className="section-subtitle">{PROGRAM_GUN_ETIKETLERI[bugun] || 'Bugun'} gunundeki dersleriniz</div>
              </div>
            </div>
            {bugunDersleri.length === 0 ? (
              <div style={{ borderRadius: 14, padding: '18px 16px', background: 'linear-gradient(135deg, #F8FAFF 0%, #EEF4FF 100%)', border: '1px solid #D9E6FF', color: 'var(--text-muted)' }}>
                Bugun icin ders gorunmuyor.
              </div>
            ) : (
              <div style={{ display: 'grid', gap: 10 }}>
                {bugunDersleri.map((ders, index) => (
                  <div
                    key={ders.id}
                    style={{
                      display: 'grid',
                      gridTemplateColumns: isMobile ? '70px minmax(0, 1fr)' : '78px minmax(0, 1fr) 96px',
                      gap: 10,
                      alignItems: 'center',
                      padding: '12px 14px',
                      borderRadius: 14,
                      border: `1px solid ${(ders.renk || '#3B82F6')}35`,
                      background: `linear-gradient(135deg, ${(ders.renk || '#3B82F6')}16 0%, #FFFFFF 92%)`,
                    }}
                  >
                    <div style={{ borderRadius: 12, background: '#fff', border: `1px solid ${(ders.renk || '#3B82F6')}30`, padding: '8px 8px' }}>
                      <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>Ders {index + 1}</div>
                      <div style={{ fontWeight: 800, fontSize: '0.86rem', marginTop: 3 }}>{ders.baslangic_saati}</div>
                      <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>{ders.bitis_saati}</div>
                    </div>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 800, fontSize: '0.9rem', color: ders.renk || 'var(--text-primary)' }}>{ders.ders_adi}</div>
                      <div style={{ marginTop: 3, fontSize: '0.8rem', fontWeight: 600 }}>{ders.ogretmen_adi}</div>
                      <div style={{ marginTop: 6, fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                        {ders.salonno ? `Salon ${ders.salonno}` : 'Salon bilgisi yok'}
                      </div>
                    </div>
                    {!isMobile && <div style={{ textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', padding: '6px 10px', borderRadius: 999, background: '#fff', border: `1px solid ${(ders.renk || '#3B82F6')}35`, fontSize: '0.7rem', fontWeight: 700, color: ders.renk || 'var(--text-primary)' }}>
                        {PROGRAM_GUN_ETIKETLERI[bugun]}
                      </div>
                    </div>}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="card" style={{ padding: 18, overflowX: 'hidden', background: 'linear-gradient(180deg, #FFFFFF 0%, #FBFCFF 100%)' }}>
            <div className="section-header" style={{ marginBottom: 14 }}>
              <div>
                <div className="section-title">Haftalik Cizelge</div>
                <div className="section-subtitle">Sinifinizin tum haftalik planini gosterir.</div>
              </div>
            </div>
            {!ogrenci?.sinif_id ? (
              <div className="empty-state"><p>Sinif bilginiz bulunamadi.</p></div>
            ) : aktifGunler.length === 0 || tumSlotlar.length === 0 ? (
              <div className="empty-state"><p>Program saatleri tanimlanmamis.</p></div>
            ) : (
              <>
              {isMobile && aktifGunler.length > 0 && (
                <div style={{ display: 'flex', gap: 8, marginBottom: 10, overflowX: 'auto', paddingBottom: 2 }}>
                  {aktifGunler.map((g) => (
                    <button
                      key={g}
                      className="btn btn-sm"
                      onClick={() => setMobilGun(g)}
                      style={{
                        flex: '0 0 auto',
                        padding: '6px 10px',
                        borderRadius: 999,
                        border: '1px solid var(--border)',
                        background: aktifMobilGun === g ? 'var(--accent)' : 'var(--bg-elevated)',
                        color: aktifMobilGun === g ? '#fff' : 'var(--text-secondary)',
                        fontWeight: 700,
                      }}
                    >
                      {PROGRAM_GUN_KISA[g]}
                    </button>
                  ))}
                </div>
              )}
              <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'fixed' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left', padding: '12px 10px', background: '#F3F7FF', borderBottom: '1px solid #DCE7F8', width: 78 }}>Saat</th>
                    {gorunenGunler.map((gun) => (
                      <th key={gun} style={{ padding: '12px 10px', background: '#F3F7FF', borderBottom: '1px solid #DCE7F8', textAlign: 'left' }}>
                        <div style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, fontSize: '0.82rem' }}>{PROGRAM_GUN_ETIKETLERI[gun]}</div>
                        <div style={{ fontSize: '0.64rem', color: 'var(--text-muted)', marginTop: 2 }}>
                          {gunSaatleri?.[gun]?.bas} - {gunSaatleri?.[gun]?.bit}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tumSlotlar.map((slot) => (
                    <tr key={`${slot.bas}_${slot.bit}`}>
                      <td style={{ padding: '12px 8px', borderBottom: '1px solid #EEF2F7', background: '#FCFDFF', verticalAlign: 'top' }}>
                        <div style={{ fontWeight: 800, color: '#17315C', fontSize: '0.82rem' }}>{slot.bas}</div>
                        <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>{slot.bit}</div>
                      </td>
                      {gorunenGunler.map((gun) => {
                        const ders = programMap[`${gun}_${slot.bas}`];
                        return (
                          <td key={`${gun}_${slot.bas}`} style={{ padding: 5, borderBottom: '1px solid #EEF2F7', borderLeft: '1px solid #F2F4F8', verticalAlign: 'top', background: ders ? '#fff' : 'rgba(245, 248, 255, 0.45)' }}>
                            {ders ? (
                              <div style={{ borderRadius: 12, padding: '9px 10px', minHeight: 84, border: `1px solid ${(ders.renk || '#3B82F6')}35`, background: `linear-gradient(135deg, ${(ders.renk || '#3B82F6')}16 0%, #FFFFFF 100%)`, boxShadow: '0 6px 14px rgba(15,30,61,0.05)' }}>
                                <div style={{ fontWeight: 800, color: ders.renk || 'var(--text-main)', marginBottom: 4, fontSize: '0.8rem', lineHeight: 1.2 }}>{ders.ders_adi}</div>
                                <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#17315C', lineHeight: 1.25 }}>{ders.ogretmen_adi}</div>
                                <div style={{ fontSize: '0.64rem', color: 'var(--text-muted)', marginTop: 6 }}>{ders.baslangic_saati} - {ders.bitis_saati}</div>
                                <div style={{ fontSize: '0.64rem', color: 'var(--text-muted)', marginTop: 2 }}>{ders.salonno ? `Salon ${ders.salonno}` : 'Salon bilgisi yok'}</div>
                              </div>
                            ) : (
                              <div style={{ minHeight: 84, borderRadius: 12, background: 'repeating-linear-gradient(135deg, rgba(220,231,248,0.34) 0, rgba(220,231,248,0.34) 8px, rgba(255,255,255,0.75) 8px, rgba(255,255,255,0.75) 16px)', border: '1px dashed #E2E8F0' }} />
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

function formatCalismaTarihi(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
}

function getCalismaRenk(detay = {}) {
  const renkler = ['#06B6D4', '#F59E0B', '#8B5CF6', '#F97316', '#7C3AED', '#EF4444', '#10B981'];
  const key = String(detay.ders_id || detay.ders_adi || detay.konu || '');
  const toplam = key.split('').reduce((sum, ch) => sum + ch.charCodeAt(0), 0);
  return renkler[toplam % renkler.length] || '#3B82F6';
}

export function OgrenciCalismaProgramlariPage() {
  const [loading, setLoading] = useState(true);
  const [detayLoading, setDetayLoading] = useState(false);
  const [programlar, setProgramlar] = useState([]);
  const [seciliProgramId, setSeciliProgramId] = useState(null);
  const [seciliProgramDetay, setSeciliProgramDetay] = useState(null);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 900);
  const [mobilGun, setMobilGun] = useState('Pazartesi');

  const loadProgramlar = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('/ogrenci/calisma-programlarim');
      const list = data?.success ? (data.data || []) : [];
      setProgramlar(list);
      setSeciliProgramId(prev => prev || list[0]?.id || null);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Çalışma programların yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProgramlar();
  }, [loadProgramlar]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (!seciliProgramId) {
      setSeciliProgramDetay(null);
      return;
    }

    const listProgram = programlar.find(item => item.id === seciliProgramId);
    if (Array.isArray(listProgram?.detaylar) && listProgram.detaylar.length > 0) {
      setSeciliProgramDetay(listProgram);
      return;
    }

    let aktif = true;
    setDetayLoading(true);
    axios.get(`/ogrenci/calisma-programlarim/${seciliProgramId}`)
      .then(({ data }) => {
        if (!aktif) return;
        if (data?.success) setSeciliProgramDetay(data.data || null);
      })
      .catch((err) => {
        if (!aktif) return;
        toast.error(err.response?.data?.message || 'Program detayı yüklenemedi');
        setSeciliProgramDetay(listProgram || null);
      })
      .finally(() => {
        if (aktif) setDetayLoading(false);
      });

    return () => {
      aktif = false;
    };
  }, [programlar, seciliProgramId]);

  const seciliProgram = seciliProgramDetay || programlar.find(item => item.id === seciliProgramId) || programlar[0] || null;
  const seciliProgramTuru = CALISMA_PROGRAM_TURU[seciliProgram?.program_turu] || CALISMA_PROGRAM_TURU.gunluk;
  const detaylar = seciliProgram?.detaylar || [];
  const calismaDetaylari = seciliProgram?.program_turu === 'calisma' ? detaylar : [];
  const slotNoList = [...new Set(detaylar.map(detay => Number(detay.slot_no) || 1))].sort((a, b) => a - b);
  const tabloSlotlari = slotNoList.length > 0
    ? Array.from({ length: Math.max(6, slotNoList[slotNoList.length - 1]) }, (_, index) => index + 1)
    : [1, 2, 3, 4, 5, 6];

  const gunGruplari = detaylar.reduce((acc, detay) => {
    const gunKey = detay.gun || 'Diger';
    if (!acc[gunKey]) acc[gunKey] = [];
    acc[gunKey].push(detay);
    return acc;
  }, {});

  const siraliGunler = Object.keys(gunGruplari).sort((a, b) => {
    const indexA = PROGRAM_GUNLERI.indexOf(a);
    const indexB = PROGRAM_GUNLERI.indexOf(b);
    if (indexA === -1 && indexB === -1) return a.localeCompare(b, 'tr');
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });

  siraliGunler.forEach(gun => {
    gunGruplari[gun].sort((a, b) => (Number(a.slot_no) || 0) - (Number(b.slot_no) || 0));
  });

  const bugun = ['Pazar', 'Pazartesi', 'Sali', 'Carsamba', 'Persembe', 'Cuma', 'Cumartesi'][new Date().getDay()];
  const bugunkuDetaylar = seciliProgram?.program_turu === 'calisma'
    ? detaylar
    : (gunGruplari[bugun] || []).sort((a, b) => (Number(a.slot_no) || 0) - (Number(b.slot_no) || 0));
  const tabloGunleri = seciliProgram?.program_turu === 'haftalik'
    ? PROGRAM_GUNLERI
    : siraliGunler.length > 0
      ? siraliGunler
      : [bugun];
  const aktifMobilGun = tabloGunleri.includes(mobilGun) ? mobilGun : (tabloGunleri[0] || bugun);
  const gorunenTabloGunleri = isMobile ? [aktifMobilGun] : tabloGunleri;
  const detayMap = {};
  detaylar.forEach(detay => {
    detayMap[`${detay.gun}_${Number(detay.slot_no) || 1}`] = detay;
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <style>{`
        .ogrenci-calisma-layout {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .ogrenci-calisma-topbar {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(320px, 0.72fr);
          gap: 14px;
          align-items: stretch;
        }
        .ogrenci-calisma-bottom {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(230px, 0.62fr);
          gap: 14px;
          align-items: start;
        }
        .ogrenci-calisma-program-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .ogrenci-calisma-program-card {
          width: 100%;
          text-align: left;
          border: 1px solid var(--border);
          border-radius: 18px;
          background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%);
          padding: 16px;
          cursor: pointer;
          transition: all var(--dur-normal) var(--ease);
          box-shadow: var(--shadow-card);
        }
        .ogrenci-calisma-program-card:hover {
          transform: translateY(-1px);
          box-shadow: var(--shadow-sm);
        }
        .ogrenci-calisma-program-card.active {
          border-color: var(--accent-border);
          background: linear-gradient(180deg, rgba(232,51,74,0.06), rgba(255,255,255,1));
          box-shadow: var(--shadow-red);
        }
        .ogrenci-calisma-panel {
          border-radius: 18px;
          border: 1px solid var(--border);
          background: linear-gradient(180deg, rgba(255,255,255,0.99), rgba(245,247,255,0.96));
          box-shadow: var(--shadow-card);
        }
        .ogrenci-calisma-gun-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 14px;
        }
        .ogrenci-calisma-detay-card {
          border: 1px solid var(--border);
          border-radius: 16px;
          padding: 14px;
          background: var(--bg-card);
        }
        .ogrenci-calisma-table-wrap {
          overflow-x: auto;
          border: 1px solid var(--border-blue);
          border-radius: 18px;
          background: linear-gradient(180deg, #FFFFFF 0%, #FBFCFF 100%);
        }
        .ogrenci-calisma-table {
          width: 100%;
          min-width: 760px;
          border-collapse: collapse;
        }
        .ogrenci-calisma-table th,
        .ogrenci-calisma-table td {
          border-right: 1px solid var(--border);
          border-bottom: 1px solid var(--border);
          vertical-align: top;
        }
        .ogrenci-calisma-table th:last-child,
        .ogrenci-calisma-table td:last-child {
          border-right: none;
        }
        .ogrenci-calisma-table tr:last-child td {
          border-bottom: none;
        }
        .ogrenci-calisma-empty-cell {
          min-height: 96px;
          border-radius: 14px;
          background: linear-gradient(180deg, rgba(37,99,235,0.04), rgba(255,255,255,0.9));
          border: 1px dashed rgba(37,99,235,0.18);
          display: flex;
          align-items: center;
          padding: 14px;
          color: #7A8BB0;
          font-size: 0.8rem;
          line-height: 1.25;
        }
        .ogrenci-calisma-filled-cell {
          min-height: 96px;
          border-radius: 14px;
          padding: 12px;
          border: 1px solid rgba(37,99,235,0.14);
          background: linear-gradient(180deg, rgba(219,234,254,0.78), rgba(255,255,255,1));
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.85);
        }
        .ogrenci-calisma-cell-title {
          font-weight: 800;
          font-size: 0.84rem;
          color: #17315C;
        }
        .ogrenci-calisma-cell-meta {
          font-size: 0.72rem;
          color: var(--accent);
          font-weight: 700;
        }
        .ogrenci-calisma-cell-topic {
          margin-top: 6px;
          font-size: 0.82rem;
          color: #334E7D;
          font-weight: 700;
          line-height: 1.3;
        }
        .ogrenci-calisma-cell-note {
          margin-top: 8px;
          font-size: 0.75rem;
          color: #596C95;
          white-space: pre-line;
          line-height: 1.35;
        }
        @media (max-width: 1280px) {
          .ogrenci-calisma-topbar,
          .ogrenci-calisma-bottom {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 1024px) {
          .ogrenci-calisma-layout,
          .ogrenci-calisma-gun-grid,
          .ogrenci-calisma-topbar,
          .ogrenci-calisma-bottom {
            grid-template-columns: 1fr;
          }
        }
        @media (max-width: 900px) {
          .ogrenci-calisma-table {
            min-width: 100%;
          }
        }
      `}</style>

      <div
        className="animate-fadeInUp"
        style={{
          background: 'linear-gradient(135deg, #1A2E5A 0%, #2148A6 55%, #E8334A 100%)',
          borderRadius: 24,
          padding: '22px 24px',
          color: '#fff',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 14px 30px rgba(33, 72, 166, 0.18)',
        }}
      >
        <div style={{ position: 'absolute', right: -24, top: -18, width: 130, height: 130, borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ fontSize: '0.72rem', letterSpacing: '0.14em', textTransform: 'uppercase', opacity: 0.74, fontWeight: 800 }}>
            Calisma Programim
          </div>
          <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <h2 style={{ margin: 0, fontFamily: 'var(--font-ui)', fontSize: '1.75rem', lineHeight: 1.05, fontWeight: 800 }}>
                Kendi Programını Takip Et
              </h2>
              <div style={{ marginTop: 6, fontSize: '0.9rem', color: 'rgba(255,255,255,0.84)', maxWidth: 720 }}>
                Rehber öğretmenin senin için hazırladığı çalışma planlarını burada görebilir, gün gün ilerleyebilirsin.
              </div>
            </div>
            <button onClick={loadProgramlar} className="btn btn-outline" style={{ background: 'rgba(255,255,255,0.12)', color: '#fff', borderColor: 'rgba(255,255,255,0.22)' }}>
              Yenile
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="page-loader"><div className="spinner" /></div>
      ) : programlar.length === 0 ? (
        <div className="card">
          <div className="empty-state" style={{ padding: '42px 0' }}>
            <div style={{ fontSize: '2.4rem' }}>📘</div>
            <h3>Henüz çalışma programın yok</h3>
            <p>Rehber öğretmenin sana bir plan tanımladığında burada görünecek.</p>
          </div>
        </div>
      ) : (
        <>
          <div className="animate-fadeInUp stagger-1" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
            <div className="stat-card" style={{ '--stat-color': '#2563EB', padding: 14 }}>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Toplam Program</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.65rem', fontWeight: 900 }}>{programlar.length}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Sana atanan plan sayısı</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#10B981', padding: 14 }}>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Seçili Program</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.05rem', fontWeight: 900, lineHeight: 1.2 }}>{seciliProgram?.baslik || '—'}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>{seciliProgramTuru.helper}</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#7C3AED', padding: 14 }}>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Bugünkü Oturum</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.65rem', fontWeight: 900 }}>{bugunkuDetaylar.length}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>{PROGRAM_GUN_ETIKETLERI[bugun] || 'Bugün'} için planlanan çalışma</div>
            </div>
            <div className="stat-card" style={{ '--stat-color': '#F97316', padding: 14 }}>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Toplam Detay</div>
              <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.65rem', fontWeight: 900 }}>{detaylar.length}</div>
              <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', marginTop: 4 }}>Tüm oturum sayısı</div>
            </div>
          </div>

          <div className="ogrenci-calisma-layout animate-fadeInUp stagger-2">
            <div className="ogrenci-calisma-topbar">
              <div className="card ogrenci-calisma-panel">
                <div className="section-header" style={{ marginBottom: 12 }}>
                  <div>
                    <div className="section-title">{seciliProgram?.baslik || 'Program Detayı'}</div>
                    <div className="section-subtitle">
                      {formatCalismaTarihi(seciliProgram?.baslangic_tarihi)}
                      {seciliProgram?.bitis_tarihi ? ` - ${formatCalismaTarihi(seciliProgram?.bitis_tarihi)}` : ''}
                    </div>
                  </div>
                  <span className={`badge ${seciliProgramTuru.badge}`}>
                    {seciliProgramTuru.planLabel}
                  </span>
                </div>

                {seciliProgram?.hedef && (
                  <div style={{ padding: '12px 14px', borderRadius: 14, background: 'linear-gradient(180deg, rgba(232,51,74,0.08), rgba(255,255,255,0.98))', color: 'var(--accent)', fontSize: '0.84rem', marginBottom: 14, border: '1px solid var(--accent-border)' }}>
                    🎯 {seciliProgram.hedef}
                  </div>
                )}

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
                  <div style={{ padding: '12px 14px', borderRadius: 14, background: 'var(--bg-elevated)', border: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Toplam Oturum</div>
                    <div style={{ fontWeight: 800, fontSize: '1.2rem' }}>{detaylar.length}</div>
                  </div>
                  <div style={{ padding: '12px 14px', borderRadius: 14, background: 'var(--bg-elevated)', border: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Bugünkü Plan</div>
                    <div style={{ fontWeight: 800, fontSize: '1.2rem' }}>{bugunkuDetaylar.length} oturum</div>
                  </div>
                  <div style={{ padding: '12px 14px', borderRadius: 14, background: 'var(--bg-elevated)', border: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Program Türü</div>
                    <div style={{ fontWeight: 800, fontSize: '1rem' }}>{seciliProgramTuru.label}</div>
                  </div>
                </div>
              </div>

              <div className="ogrenci-calisma-panel" style={{ padding: '14px 16px', background: 'linear-gradient(135deg, #F7FAFF 0%, #EEF3FF 100%)' }}>
                <div style={{ fontWeight: 800, marginBottom: 8, color: '#17315C' }}>Bugünkü Odak</div>
                {detayLoading ? (
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>Program detayları yükleniyor...</div>
                ) : bugunkuDetaylar.length === 0 ? (
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>Bugün için özel çalışma oturumu görünmüyor.</div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {bugunkuDetaylar.map(detay => (
                      <div key={`${detay.gun}-${detay.slot_no}`} style={{ padding: '10px 12px', borderRadius: 12, background: '#fff', border: '1px solid var(--border-blue)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                          <div style={{ fontWeight: 700 }}>{detay.slot_etiketi}</div>
                          <div style={{ fontSize: '0.76rem', color: 'var(--accent)' }}>{detay.soru_sayisi ? `${detay.soru_sayisi} soru` : 'Soru sayısı yok'}</div>
                        </div>
                        <div style={{ marginTop: 4, color: '#17315C', fontWeight: 700 }}>{detay.ders_adi || 'Ders'}</div>
                        {detay.konu && <div style={{ marginTop: 4, color: 'var(--text-secondary)', fontSize: '0.8rem' }}>{detay.konu}</div>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="card ogrenci-calisma-panel" style={{ padding: 18, overflowX: 'hidden', background: 'linear-gradient(180deg, #FFFFFF 0%, #FBFCFF 100%)' }}>
              <div style={{ padding: '16px 18px', borderBottom: '1px solid var(--border)' }}>
                <div className="section-title">{seciliProgram?.program_turu === 'calisma' ? 'Çalışma Detayı' : 'Program Tablosu'}</div>
                <div className="section-subtitle">
                  {seciliProgram?.program_turu === 'haftalik'
                    ? 'Haftalık planın tamamını tablo görünümünde incele.'
                    : seciliProgram?.program_turu === 'calisma'
                      ? 'Ders, konu, not ve çalışma süresini incele.'
                      : 'Günlük planını oturum bazında tablo olarak gör.'}
                </div>
              </div>

              {seciliProgram?.program_turu === 'calisma' ? (
                <div style={{ padding: 16 }}>
                  {detayLoading ? (
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>Program detayları yükleniyor...</div>
                  ) : calismaDetaylari.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      {calismaDetaylari.map((detay, index) => (
                        <div key={`${detay.id || index}-${detay.ders_id}`} style={{ borderRadius: 14, padding: 16, border: '1px solid var(--border-blue)', background: 'linear-gradient(135deg, #F7FAFF 0%, #FFFFFF 100%)' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                            <div>
                              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Ders</div>
                              <div style={{ fontWeight: 900, color: '#17315C', fontSize: '1rem' }}>{index + 1}. {detay.ders_adi || 'Ders'}</div>
                            </div>
                            <span className="badge badge-success">{detay.soru_sayisi ? `${detay.soru_sayisi} gün` : 'Gün sayısı yok'}</span>
                          </div>
                          {detay.konu && (
                            <div style={{ marginTop: 14 }}>
                              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Konu</div>
                              <div style={{ fontWeight: 800, color: '#17315C' }}>{detay.konu}</div>
                            </div>
                          )}
                          {detay.aciklama && (
                            <div style={{ marginTop: 14 }}>
                              <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: 4 }}>Not</div>
                              <div style={{ color: 'var(--text-secondary)', fontSize: '0.84rem', whiteSpace: 'pre-line' }}>{detay.aciklama}</div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>Bu çalışma programı için detay bulunamadı.</div>
                  )}
                </div>
              ) : (
                <>
                  {isMobile && (
                    <div style={{ display: 'flex', gap: 8, padding: '10px 12px 0', overflowX: 'auto' }}>
                      {tabloGunleri.map((gun) => (
                        <button
                          key={gun}
                          className="btn btn-sm"
                          onClick={() => setMobilGun(gun)}
                          style={{
                            flex: '0 0 auto',
                            borderRadius: 999,
                            border: '1px solid var(--border)',
                            background: aktifMobilGun === gun ? 'var(--accent)' : 'var(--bg-elevated)',
                            color: aktifMobilGun === gun ? '#fff' : 'var(--text-secondary)',
                            fontWeight: 700,
                            padding: '6px 10px',
                          }}
                        >
                          {PROGRAM_GUN_KISA[gun] || gun}
                        </button>
                      ))}
                    </div>
                  )}

                  <div className="ogrenci-calisma-table-wrap">
                    {detayLoading && (
                      <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                        Program detayları yükleniyor...
                      </div>
                    )}
                    <table className="ogrenci-calisma-table" style={{ tableLayout: 'fixed' }}>
                  <thead>
                    <tr>
                      <th style={{ width: 86, textAlign: 'left', padding: '12px 10px', background: '#F3F7FF', borderBottom: '1px solid #DCE7F8', color: '#17315C' }}>Oturum</th>
                      {gorunenTabloGunleri.map(gun => (
                        <th key={gun} style={{ minWidth: 170, padding: '12px 10px', background: '#F3F7FF', borderBottom: '1px solid #DCE7F8', textAlign: 'left' }}>
                          <div style={{ fontWeight: 800, fontSize: '0.84rem' }}>{PROGRAM_GUN_ETIKETLERI[gun] || gun}</div>
                          <div style={{ marginTop: 2, fontSize: '0.68rem', color: 'var(--text-muted)' }}>
                            {gun === bugun ? 'Bugün' : 'Plan günü'}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tabloSlotlari.map(slotNo => (
                      <tr key={slotNo}>
                        <td style={{ padding: '12px 8px', borderBottom: '1px solid #EEF2F7', background: '#FCFDFF', verticalAlign: 'top' }}>
                          <div style={{ fontWeight: 800, color: '#17315C', fontSize: '0.82rem' }}>
                            {detaylar.find(detay => Number(detay.slot_no) === slotNo)?.slot_etiketi || `${slotNo}. Oturum`}
                          </div>
                          <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)', marginTop: 3 }}>Günün çalışma bloğu</div>
                        </td>
                        {gorunenTabloGunleri.map(gun => {
                          const detay = detayMap[`${gun}_${slotNo}`];
                          const renk = detay ? getCalismaRenk(detay) : '#3B82F6';
                          return (
                            <td key={`${gun}_${slotNo}`} style={{ padding: 5, borderBottom: '1px solid #EEF2F7', borderLeft: '1px solid #F2F4F8', verticalAlign: 'top', background: detay ? '#fff' : 'rgba(245, 248, 255, 0.45)' }}>
                              {detay ? (
                                <div style={{ borderRadius: 12, padding: '9px 10px', minHeight: 84, border: `1px solid ${renk}35`, background: `linear-gradient(135deg, ${renk}16 0%, #FFFFFF 100%)`, boxShadow: '0 6px 14px rgba(15,30,61,0.05)' }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
                                    <div style={{ fontWeight: 800, color: renk, marginBottom: 4, fontSize: '0.8rem', lineHeight: 1.2 }}>{detay.ders_adi || 'Ders'}</div>
                                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', fontWeight: 700 }}>{detay.soru_sayisi ? `${detay.soru_sayisi} soru` : ''}</div>
                                  </div>
                                  {detay.konu && <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#17315C', lineHeight: 1.25 }}>{detay.konu}</div>}
                                  {detay.aciklama && (
                                    <div style={{ fontSize: '0.64rem', color: 'var(--text-muted)', marginTop: 6, whiteSpace: 'pre-line' }}>
                                      {detay.aciklama}
                                    </div>
                                  )}
                                  {!detay.aciklama && <div style={{ fontSize: '0.64rem', color: 'var(--text-muted)', marginTop: 6 }}>Çalışma açıklaması yok</div>}
                                </div>
                              ) : (
                                <div style={{ minHeight: 84, borderRadius: 12, background: 'repeating-linear-gradient(135deg, rgba(220,231,248,0.34) 0, rgba(220,231,248,0.34) 8px, rgba(255,255,255,0.75) 8px, rgba(255,255,255,0.75) 16px)', border: '1px dashed #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94A3C7', fontSize: '0.74rem', padding: 10, textAlign: 'center' }}>
                                  Ders ve çalışma bilgisi eklenecek
                                </div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>

            <div className="ogrenci-calisma-bottom">
              <div className="card ogrenci-calisma-panel">
                <div className="section-title" style={{ marginBottom: 12 }}>Programlarım</div>
                <div className="ogrenci-calisma-program-list">
                  {programlar.map(program => (
                    <button
                      key={program.id}
                      type="button"
                      className={`ogrenci-calisma-program-card ${seciliProgram?.id === program.id ? 'active' : ''}`}
                      onClick={() => setSeciliProgramId(program.id)}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'flex-start' }}>
                        <div>
                          <div style={{ fontWeight: 800, fontSize: '0.95rem' }}>{program.baslik || 'Çalışma Programı'}</div>
                          <div style={{ marginTop: 4, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                            {formatCalismaTarihi(program.baslangic_tarihi)}
                            {program.bitis_tarihi ? ` - ${formatCalismaTarihi(program.bitis_tarihi)}` : ''}
                          </div>
                        </div>
                        <span className={`badge ${CALISMA_PROGRAM_TURU[program.program_turu]?.badge || 'badge-muted'}`}>
                          {CALISMA_PROGRAM_TURU[program.program_turu]?.label || 'Program'}
                        </span>
                      </div>
                      {program.hedef && (
                        <div style={{ marginTop: 10, padding: '10px 12px', borderRadius: 12, background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontSize: '0.8rem' }}>
                          🎯 {program.hedef}
                        </div>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              <div className="card ogrenci-calisma-panel">
                <div className="section-title" style={{ marginBottom: 12 }}>{seciliProgram?.program_turu === 'calisma' ? 'Çalışma Özeti' : 'Haftalık Özet'}</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {tabloGunleri.map(gun => (
                    <div key={gun} style={{ padding: '12px 14px', borderRadius: 14, background: gun === bugun ? 'rgba(232,51,74,0.07)' : 'var(--bg-elevated)', border: `1px solid ${gun === bugun ? 'var(--accent-border)' : 'var(--border)'}` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                        <div style={{ fontWeight: 700 }}>{PROGRAM_GUN_ETIKETLERI[gun] || gun}</div>
                        <span className={`badge ${gun === bugun ? 'badge-success' : 'badge-muted'}`}>
                          {seciliProgram?.program_turu === 'calisma'
                            ? `${(gunGruplari[gun] || []).reduce((sum, detay) => sum + (Number(detay.soru_sayisi) || 0), 0)} gün`
                            : `${(gunGruplari[gun] || []).length} oturum`}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

// ── 2. ODEVLER ─────────────────────────────────────────────────
export function OgrenciOdevlerPage() {
  const [odevler, setOdevler] = useState([]);
  const [loading, setLoading] = useState(true);

  const DURUM_BADGE = {
    teslim_edildi: { label: 'Teslim Edildi', bg: '#D1FAE5', color: '#065F46' },
    teslim_edilmedi: { label: 'Teslim Edilmedi', bg: '#FEE2E2', color: '#991B1B' },
    gec_teslim: { label: 'Geç Teslim', bg: '#FEF3C7', color: '#92400E' },
  };

  const STATUS_LABELS = {
    400: 'Geçersiz istek (400)',
    403: 'Bu işlem için yetkiniz yok (403)',
    404: 'Ödev kayıtları bulunamadı (404)',
    500: 'Sunucu hatası oluştu (500)',
  };

  const showApiError = (err, fallback) => {
    const status = err?.response?.status;
    const data = err?.response?.data || {};
    const baseMsg = data?.message || data?.error || fallback;
    const prefix = STATUS_LABELS[status];
    toast.error(prefix ? `${prefix}: ${baseMsg}` : baseMsg);
  };

  const loadOdevler = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get('/odevler');
      if (data.success) {
        setOdevler(data.data || []);
      } else {
        setOdevler([]);
      }
    } catch (err) {
      showApiError(err, 'Ödevler yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadOdevler();
  }, [loadOdevler]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📝 Ödevlerim</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{odevler.length} ödev listelendi</p>
        </div>
        <button className="btn btn-outline btn-sm" onClick={loadOdevler}>
          Yenile
        </button>
      </div>

      {loading ? (
        <div className="page-loader" style={{ minHeight: 140 }}>
          <div className="spinner" />
        </div>
      ) : odevler.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 10 }}>🗂️</div>
          <h3 style={{ fontFamily: 'var(--font-ui)', marginBottom: 6 }}>Ödev bulunamadı</h3>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Sana atanmış bir ödev henüz yok.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {odevler.map((o, i) => {
            const durum = DURUM_BADGE[o.durum] || { label: o.durum || '-', bg: 'var(--bg-elevated)', color: 'var(--text-secondary)' };
            return (
              <div key={o.id || i} className="card animate-fadeInUp" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: '1rem' }}>{o.baslik}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>
                      {o.ders_adi || '-'} · {o.ogretmen_adi || '-'}
                    </div>
                  </div>
                  <span className="badge" style={{ background: durum.bg, color: durum.color }}>
                    {durum.label}
                  </span>
                </div>

                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <span className="badge badge-info">Konu: {o.konu || '-'}</span>
                  <span className="badge badge-muted">{o.soru_sayisi || '-'} soru</span>
                </div>
                {o.aciklama && <div style={{ fontSize: '0.86rem', color: 'var(--text-secondary)' }}>{o.aciklama}</div>}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                  <div>Veriliş: {o.verilis_tarihi ? new Date(o.verilis_tarihi).toLocaleDateString('tr-TR') : '-'}</div>
                  <div>Teslim: {o.teslim_tarihi ? new Date(o.teslim_tarihi).toLocaleDateString('tr-TR') : '-'}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── 3. ETÜT TALEBİ ──────────────────────────────────────────────
export function EtutTalepPage() {
  const [dersler, setDersler] = useState([]);
  const [taleplerlerim, setTaleplerim] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ ders_id: '', konu: '', aciklama: '', tercih_tarihi: '' });
  const [gonderiyor, setGonderiyor] = useState(false);

  useEffect(() => {
    Promise.all([
      axios.get('/dersler'),
      axios.get('/ogrenci/etut-taleplerim'),
    ]).then(([dRes, tRes]) => {
      if (dRes.data.success) setDersler(dRes.data.data);
      if (tRes.data.success) setTaleplerim(tRes.data.data);
    }).catch(() => { }).finally(() => setLoading(false));
  }, []);

  const handleGonder = async () => {
    if (!form.ders_id) { toast.error('Ders seçin'); return; }
    setGonderiyor(true);
    try {
      await axios.post('/ogrenci/etut-talep', form);
      toast.success('Etüt talebiniz gönderildi!');
      setForm({ ders_id: '', konu: '', aciklama: '', tercih_tarihi: '' });
      const tRes = await axios.get('/ogrenci/etut-taleplerim');
      if (tRes.data.success) setTaleplerim(tRes.data.data);
    } catch { toast.error('Gönderim hatası'); }
    finally { setGonderiyor(false); }
  };

  const DURUM_COLORS = { bekliyor: 'var(--accent)', onaylandi: '#10B981', reddedildi: '#EF4444', tamamlandi: '#3B82F6' };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>📚 Etüt Talebi</h2>
        <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginTop: 4 }}>Rehber öğretmeninizden etüt desteği talep edin</p>
      </div>

      <div className="grid-2 animate-fadeInUp stagger-1">
        <div className="card">
          <div className="section-title" style={{ marginBottom: 16 }}>+ Yeni Talep</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div className="form-group">
              <label className="form-label">Ders *</label>
              <select className="form-select" value={form.ders_id} onChange={e => setForm({ ...form, ders_id: e.target.value })}>
                <option value="">Ders seçin</option>
                {dersler.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Konu</label>
              <input className="form-input" placeholder="Türev, integral..." value={form.konu} onChange={e => setForm({ ...form, konu: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Açıklama</label>
              <textarea className="form-textarea" placeholder="Hangi konularda zorlandığınızı açıklayın..." value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} style={{ minHeight: 80 }} />
            </div>
            <div className="form-group">
              <label className="form-label">Tercih Ettiğiniz Tarih</label>
              <input className="form-input" type="date" value={form.tercih_tarihi} onChange={e => setForm({ ...form, tercih_tarihi: e.target.value })} />
            </div>
            <button className="btn btn-primary" style={{ justifyContent: 'center', cursor: 'pointer' }} onClick={handleGonder} disabled={gonderiyor}>
              {gonderiyor ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Gönderiliyor...</> : '📤 Talep Gönder'}
            </button>
          </div>
        </div>

        <div className="card">
          <div className="section-title" style={{ marginBottom: 14 }}>📋 Taleplerim</div>
          {loading ? <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div> :
            taleplerlerim.length === 0 ? <div className="empty-state"><p>Henüz talep göndermediniz</p></div> :
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {taleplerlerim.map((t, i) => (
                  <div key={i} style={{
                    padding: '12px 14px', background: 'var(--bg-elevated)', borderRadius: 10, border: '1px solid var(--border)',
                    borderLeft: `3px solid ${DURUM_COLORS[t.durum] || '#94A3B8'}`,
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontWeight: 700, fontSize: '0.875rem' }}>{t.ders_adi}</span>
                      <span style={{
                        background: (DURUM_COLORS[t.durum] || '#94A3B8') + '20',
                        color: DURUM_COLORS[t.durum] || '#94A3B8',
                        padding: '2px 8px', borderRadius: 99, fontSize: '0.72rem', fontWeight: 600,
                      }}>
                        {t.durum === 'bekliyor' ? '⏳ Bekliyor' : t.durum === 'onaylandi' ? '✅ Onaylandı' : t.durum === 'reddedildi' ? '❌ Reddedildi' : '✓ Tamamlandı'}
                      </span>
                    </div>
                    {t.konu && <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>{t.konu}</div>}
                    <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 4 }}>{new Date(t.created_at).toLocaleDateString('tr-TR')}</div>
                  </div>
                ))}
              </div>
          }
        </div>
      </div>
    </div>
  );
}

// ── 4. SIRALAMA ─────────────────────────────────────────────────
export function SiralamaPage() {
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 900 : false);
  const [siralama, setSiralama] = useState([]);
  const [denemeler, setDenemeler] = useState([]);
  const [seciliDeneme, setSeciliDeneme] = useState(null);
  const [loadingDenemeler, setLoadingDenemeler] = useState(true);
  const [loadingSiralama, setLoadingSiralama] = useState(false);
  const [denemeBosMesaji, setDenemeBosMesaji] = useState('');
  const MEDALS = ['🥇', '🥈', '🥉'];

  const normalizeRows = (rawRows = []) => {
    return (rawRows || [])
      .map((r, i) => ({
        _adSoyadRaw: r.ad_soyad || r.adSoyad || r.ogrenci || '',
        sira: Number(r.siralama ?? r.sira ?? i + 1),
        ad: r.ad || r.ogrenci_ad || r.isim || '',
        soyad: r.soyad || r.ogrenci_soyad || '',
        durum: (r.tip || r.durum || '').toString().toLowerCase(),
        kitapcik: r.kitapcik || r.kitapcik_turu || '-',
        numara: r.ogrenci_no || r.numara || '',
        toplam_net: Number(
          r.toplam_net ??
          r.toplamNet ??
          r.net ??
          r.toplam ??
          0
        ),
      }))
      .map((r) => {
        if (r.ad || r.soyad || !r._adSoyadRaw) return r;
        const parts = String(r._adSoyadRaw).trim().split(/\s+/);
        if (parts.length === 1) return { ...r, ad: parts[0], soyad: '' };
        return { ...r, ad: parts.slice(0, -1).join(' '), soyad: parts.slice(-1).join('') };
      })
      .sort((a, b) => a.sira - b.sira);
  };

  const extractRows = (resp) => {
    const payload = resp?.data;
    const candidates = [
      payload?.data,
      payload?.data?.data,
      payload?.data?.karneler,
      payload?.data?.sonuclar,
      payload?.karneler,
      payload?.sonuclar,
      payload,
    ];

    for (const c of candidates) {
      if (Array.isArray(c) && c.length > 0) return c;
    }
    return [];
  };

  useEffect(() => {
    const mapDenemeler = (arr = []) => (arr || []).map((d, i) => ({
      ...d,
      _id: d.id ?? d.deneme_id ?? i,
      ad: d.ad || d.deneme_adi || `Deneme ${d.id ?? d.deneme_id ?? i + 1}`,
    }));

    const loadDenemeler = async () => {
      try {
        const { data } = await axios.get('/denemeler');
        const listRaw = data?.success && Array.isArray(data?.data) ? data.data : [];
        const list = mapDenemeler(listRaw);
        setDenemeler(list);
        if (list.length > 0) {
          setSeciliDeneme(list[0].id ?? list[0]._id ?? null);
          setDenemeBosMesaji('');
        } else {
          setSeciliDeneme(null);
          setDenemeBosMesaji('Henüz deneme bulunmuyor');
        }
      } catch (err) {
        const status = err?.response?.status;
        if (status === 403) toast.error('Deneme listesine erişim yetkiniz yok');
        else if (status === 404) toast.error('Deneme bulunamadı');
        else toast.error('Deneme listesi yüklenemedi');
        setDenemeler([]);
        setSeciliDeneme(null);
        setDenemeBosMesaji('Henüz deneme bulunmuyor');
      } finally {
        setLoadingDenemeler(false);
      }
    };

    loadDenemeler();
  }, []);

  useEffect(() => {
    if (seciliDeneme === null || seciliDeneme === undefined) return;
    setLoadingSiralama(true);

    (async () => {
      try {
        const res = await axios.get(`/denemeler/${seciliDeneme}/siralama`);
        setSiralama(normalizeRows(extractRows(res)));
      } catch {
        setSiralama([]);
        toast.error('Sıralama verisi yüklenemedi');
      } finally {
        setLoadingSiralama(false);
      }
    })();
  }, [seciliDeneme]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 900);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '1.3rem' }}>🏆 Sıralama</h2>
      </div>

      <div className="card animate-fadeInUp stagger-1" style={{ padding: '14px 16px' }}>
        {isMobile ? (
          <div className="form-group" style={{ margin: 0 }}>
            <label className="form-label">Deneme</label>
            <select
              className="form-select"
              value={seciliDeneme ?? ''}
              onChange={(e) => setSeciliDeneme(e.target.value)}
            >
              {denemeler.map((d) => (
                <option key={d._id} value={d._id}>{d.ad}</option>
              ))}
            </select>
            {denemeler.length === 0 && !loadingDenemeler && (
              <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', marginTop: 6 }}>
                {denemeBosMesaji || 'Henüz deneme bulunmuyor'}
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.82rem', color: 'var(--text-muted)' }}>Deneme:</span>
            {denemeler.map((d) => (
              <button
                key={d._id}
                className={`chip ${seciliDeneme === d._id ? 'active' : ''}`}
                onClick={() => setSeciliDeneme(d._id)}
                style={{ cursor: 'pointer' }}
              >
                {d.ad}
              </button>
            ))}
            {denemeler.length === 0 && !loadingDenemeler && (
              <span style={{ fontSize: '0.82rem', color: 'var(--text-muted)' }}>{denemeBosMesaji || 'Henüz deneme bulunmuyor'}</span>
            )}
          </div>
        )}
      </div>

      <div className="card animate-fadeInUp stagger-3">
        <div className="section-title" style={{ marginBottom: 14 }}>Tam Sıralama</div>
        {(loadingDenemeler || loadingSiralama) ? (
          <div className="page-loader" style={{ minHeight: 100 }}><div className="spinner" /></div>
        ) : siralama.length === 0 ? (
          <div className="empty-state"><p>Sonuç girilmemiş</p></div>
        ) : isMobile ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {siralama.map((s, i) => (
              <div
                key={i}
                style={{
                  padding: 12,
                  borderLeft: `4px solid ${i < 3 ? 'var(--accent)' : 'var(--border)'}`,
                  border: '1px solid var(--border)',
                  borderRadius: 14,
                  background: 'var(--bg-elevated)',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                  <div style={{ fontWeight: 800, color: i < 3 ? 'var(--accent)' : 'var(--text-muted)' }}>
                    {i < 3 ? MEDALS[i] : `#${s.sira || i + 1}`}
                  </div>
                  <span className="badge" style={{ background: 'var(--bg-elevated)' }}>
                    {s.kitapcik || '-'}
                  </span>
                </div>
                <div style={{ marginTop: 6, fontWeight: 700 }}>{s.ad} {s.soyad}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>
                  No: {s.numara || 'Belirtilmemiş'}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                  <span className="badge" style={{
                    background: s.durum === 'misafir' ? '#FEF3C7' : 'var(--bg-elevated)',
                    color: s.durum === 'misafir' ? '#92400E' : 'var(--text-secondary)',
                  }}>
                    {s.durum === 'misafir' ? 'MISAFIR' : (s.durum || 'KAYITLI').toUpperCase()}
                  </span>
                  <span style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, color: 'var(--accent)' }}>
                    {parseFloat(s.toplam_net || 0).toFixed(2)} net
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Sıra</th>
                  <th>Öğrenci</th>
                  <th>Durum</th>
                  <th>Kitapçık</th>
                  <th>Toplam Net</th>
                </tr>
              </thead>
              <tbody>
                {siralama.map((s, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 800, color: i < 3 ? 'var(--accent)' : 'var(--text-muted)' }}>
                      {i < 3 ? MEDALS[i] : `#${s.sira || i + 1}`}
                    </td>
                    <td>
                      <div style={{ fontWeight: 700 }}>{s.ad} {s.soyad}</div>
                      <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                        No: {s.numara || 'Belirtilmemiş'}
                      </div>
                    </td>
                    <td>
                      <span className="badge" style={{
                        background: s.durum === 'misafir' ? '#FEF3C7' : 'var(--bg-elevated)',
                        color: s.durum === 'misafir' ? '#92400E' : 'var(--text-secondary)',
                      }}>
                        {s.durum === 'misafir' ? 'MISAFIR' : (s.durum || 'KAYITLI').toUpperCase()}
                      </span>
                    </td>
                    <td>
                      <span className="badge" style={{ background: 'var(--bg-elevated)' }}>
                        {s.kitapcik || '-'}
                      </span>
                    </td>
                    <td style={{ fontFamily: 'var(--font-ui)', fontWeight: 800, color: 'var(--accent)' }}>
                      {parseFloat(s.toplam_net || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
